<template>
  <div class="custom-ui-info-wrapper">
    <div class="custom-ui-info" :class="style">
      <div class="custom-ui-info-icon mr1">
        <i :class="icon" />
      </div>
      <div class="custom-ui-info-text">
        <span v-text="text" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { IUIInfo } from '@/types/Components'
  import { computed } from 'vue'

  const {
    icon = 'fa-solid fa-info-circle',
    text = '',
    type = 'warning',
    width = '100%',
    size = 'md',
  } = defineProps<IUIInfo>()

  const style = computed(() => ['type-' + type, 'size-' + size])
</script>

<style lang="scss">
  .custom-ui-info-wrapper {
    width: 100%;
    @include flexible();
    .custom-ui-info {
      @include flexible();
      width: v-bind(width);
      padding: 1rem;
      border-radius: 5px;

      &.size-sm {
        padding: 0.825rem;
      }

      &.size-md {
        padding: 1rem;
      }

      &.size-lg {
        padding: 1.25rem;
      }
    }
  }
</style>
